<script setup>

const props = defineProps({
    theme: Object,
    selectedRentalItem: Object,
    roundness: Object
})

</script>

<template>
    <section id="selected-rental"
             :class="[`bg-${theme.color}-50 border-${theme.color}-300 dark:border-neutral-700 dark:bg-${theme.color}-950`, roundness]"
             class="p-1.5 px-3 border shadow-sm mr-2">
        <div class="flex flex-col text-sm font-medium text-gray-800">
            <span class="text-xs font-bold opacity-70 -mb-1">{{ $t('widget.selected_rental') }}</span>
            <p>
                <span :class="`text-${theme.color}-500`" class="font-semibold"></span>
                {{selectedRentalItem.name}}
            </p>
        </div>
    </section>
</template>

<style scoped lang="scss">

</style>
